import { cn } from "@/lib/cn";

/**
 * A chart's headline: the shown value, its unit and its change on the point
 * before. `large` is the number chart's value, twice the size.
 */
export function ChartHeadline({
  value,
  unit,
  change,
  large = false,
  testId,
}: {
  value: string;
  unit: string;
  change: string | null;
  large?: boolean;
  testId: string;
}) {
  return (
    <p
      className={cn(
        "flex min-w-0 items-baseline gap-[0.2em] font-display font-medium leading-none tracking-[-0.04em] text-card-ink",
        large ? "text-[4.6em]" : "text-[2.3em]",
      )}
    >
      <span className="truncate" data-testid={testId}>
        {value}
      </span>
      {unit && (
        <span className="shrink-0 text-[0.36em] font-normal tracking-normal text-card-muted">
          {unit}
        </span>
      )}
      {change && (
        <span
          className={cn(
            "shrink-0 font-sans text-[0.36em] font-semibold tracking-normal",
            change.startsWith("-") ? "text-danger" : "text-accent",
          )}
        >
          {change}
        </span>
      )}
    </p>
  );
}

/** The first and the last point's labels, under a drawing. */
export function ChartEndLabels({
  first,
  last,
  className,
  testId,
}: {
  first: string;
  last: string;
  className?: string;
  testId?: string;
}) {
  return (
    <p
      className={cn(
        "flex justify-between gap-[0.6em] text-[0.78em] text-card-muted",
        className,
      )}
      data-testid={testId}
    >
      <span className="truncate">{first}</span>
      <span className="truncate">{last}</span>
    </p>
  );
}
